import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import useDarkMode from "../../hooks/useDarkMode";
import { login, requestOtp } from "../../redux/auth/actions";
import { useAppDispatch } from "../../hooks/hooks";
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import storePersist from "../../redux/storePersist";
import _ from "lodash";
import { getAccountTypeChannalName } from "../../common/services/common.service";
import { selectChannelListItems } from "../../redux/channel/selector";
import { userProfile } from "../../redux/userProfile/action";
import { toast } from "react-toastify";
import useWindowDimensions from "../../hooks/useWindowsDimensions";
import PageLoader from "../../components/PageLoader";
import EmailInput from "../../common/components/form/EmailInput.Component";
import PasswordInput from "../../common/components/form/PasswordInput.Component";
import { RotatingLines } from "react-loader-spinner";
import { selectCurrent } from "../../redux/settings/selectors";

export default function LoginOTP() {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const result = useSelector(selectCurrent)
    const { state } = useLocation();
    const channelListItem = useSelector(selectChannelListItems)
    const { register, handleSubmit, clearErrors, formState: { errors }, setValue } = useForm();
    const [loginValues, setLoginValues] = useState<any>()
    const [isLoginWithOTP, setIsLoginWithOTP] = React.useState(false)
    const [isOtpChecked, setIsOtpChecked] = useState(false);
    const [isRequestOtp, setIsRequestOtp] = useState(true);
    const [colorTheme, setTheme] = useDarkMode();
    const [steps, setSteps] = useState({ Email: result?.quoteData?.Email || '', Password: '' })
    const [darkSide, setDarkSide] = useState(
        colorTheme === "light" ? true : false
    );
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [baseURL, setBaseUrl] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const { height, width } = useWindowDimensions();
    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };
    const toggleDarkMode = (checked: any) => {
        setTheme(colorTheme);
        setDarkSide(checked);
    };

    const handleChange: any = (event: any, field: string) => {
        setLoginValues({ ...loginValues, [field]: event })
    }


    const handleSteps = (e: any, key: any) => {
        setSteps({ ...steps, [key]: e.target.value })
    }

    const gotoHome = (role: any) => {
        const lowerCaseRole = role?.toLocaleLowerCase();

        if (state.pageName === 'rsa' && lowerCaseRole === 'rapcustomer') {

            navigate('/order-booking')
        }
      

        else {

            navigate('/auth/login/customer')
        }

    }

    const handleForgotPassword = (e: any) => {
        e.preventDefault();
        storePersist.set('reset-pwd', 'customer')
        navigate('/auth/login/forgot-password')
    }

    const onFinish = async () => {
        await setIsLoading(true)
        if (isRequestOtp) {
            try {
                await dispatch(requestOtp({
                    loginData: {
                        Username: steps?.Email
                    }
                }))
                setIsOtpChecked(false)
                setIsLoginWithOTP(true)
            } catch (e: any) {
                toast.error('There was an error in login. Please try again...')
                console.error('Login failed:', e);
            }
            await setIsLoading(false)
        } else {
            try {
                const token = await dispatch(login({
                    loginData: {
                        "Records": [
                            {
                                "Context": {
                                    "Domain": "Mobility",
									"Platform": "iMove",
									"Network": "RAPCustomer",
									"Application": "Customer"
                                },
                                "Message": {
                                    "Username": steps?.Email,
                                    "Password": steps?.Password,
                                    "AccountType": "RAPCustomer",
                                    "LoginWithOtp": isLoginWithOTP,
                                    "Otp": loginValues?.otp || '',
                                    "IsGoogleAuthenticated": false,
                                    "AuthenticatedUserId": "",
                                    "ClientIPAddress": "",
                                    "OrganizationUnitId": 0
                                }
                            }
                        ]
                    }
                }))

                try {
                    const resp: any = await dispatch(userProfile.read({ url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/iam/user-service/user-profile/me`, entity: 'userProfile', options: { notifyOnSuccess: false, notifyOnFailed: false } }));
                    let selectedRole = ''
                    const targetRoles = ['rapcustomer']; // Roles to match
                    resp.find((element: any) =>
                        element?.Message?.Roles.find((role: any) => {
                            if (targetRoles.includes(role?.Name?.toLowerCase())) {
                                selectedRole = role.Name.toLowerCase();
                                return true;
                            }
                            return false;
                        })
                    );
                    await gotoHome(selectedRole);
                    await setIsLoading(false)
                } catch (e: any) {
                    console.error('Login failed:', e);
                    await setIsLoading(false)
                }
            } catch (e: any) {
                toast.error('There was an error in login. Please try again...')
                console.error('Login failed:', e?.Error?.Message);
                await setIsLoading(false)
            }
        }
    };

    useEffect(() => {
        setBaseUrl(window.location.origin);
        clearErrors('Email')
        clearErrors('Password')
    }, [])
    return (
        <>

            <form onSubmit={handleSubmit(onFinish)} >
                {(width && width < 724) ? <>
                    <div className="flex h-full bg-[#F8F8F8]">
                        <div className="container mx-auto px-4 ">
                            <div className="flex content-center items-center justify-start h-full">
                                <div className="w-full h-max px-6">
                                    <div className="bg-white flex flex-col items-end justify-around h-full">
                                        <div className="flex flex-col justify-center w-full h-screen px-3">
                                            <div className="flex flex-col justify-center items-center w-full text-3xl font-bold my-3">

                                                Log In
                                                <svg width="172" height="29" viewBox="0 0 172 29" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 5.08742C17.6667 19.0972 30.5 31.1305 62.5 27.2693C110.617 21.4634 150 -10.09 171 5.08727" stroke="#FFBB38"></path></svg>
                                            </div>
                                            <div className="w-full my-5">
                                                <div>
                                                    <label className="block text-sm font-light mb-2">
                                                        Email/Phone Number*
                                                    </label>
                                                    <input

                                                        type="text"
                                                        {...register('Email', {
                                                            required: true,
                                                            
                                                        })}
                                                        className="border-0 px-3 py-3 text-black rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                                        placeholder="Username"
                                                        onChange={(e) => {
                                                            handleSteps(e, 'Email'),
                                                                setValue('Email', e.target.value || steps?.Email)
                                                        }}
                                                        value={steps?.Email}

                                                    />
                                                    {errors.Email?.type === 'required' && (
                                                        <span role="alert" className="w-full text-red-500 bg-white text-xs my-1">
                                                            This is required
                                                        </span>
                                                    )}
                                                    
                                                </div>

                                            </div>
                                            <div className="w-full my-5">


                                            </div>


                                            {isLoginWithOTP && !isOtpChecked &&
                                                (<div>

                                                    <input
                                                        className="text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 d"
                                                        type="number"
                                                        placeholder="OTP"
                                                        {...register('otp', {
                                                            required: `OTP is required`,
                                                        })}
                                                        onChange={(event) => {
                                                            handleChange(
                                                                event.target.value,
                                                                'otp'
                                                            );
                                                        }}
                                                        value={loginValues?.otp}
                                                    />
                                                </div>)
                                            }




                                            <div className="text-center mt-6">

                                                {!isLoginWithOTP && (
                                                    <button type="submit" disabled={isLoading} onClick={() => setIsRequestOtp(true)} className={`${isLoading ? 'bg-primary bg-opacity-70' : 'bg-primary'
                                                        } flex-row flex items-center justify-center text-light rounded font-semibold text-xl p-4 w-full h-11`}
                                                    >Request OTP
                                                        <div className={`pl-2 ${isLoading ? 'visible' : 'invisible'}`}>
                                                            <RotatingLines
                                                                visible={true}
                                                                width={'20'}
                                                                strokeColor="#fff"
                                                                strokeWidth="6"
                                                                animationDuration="0.75"
                                                                ariaLabel="rotating-lines-loading"
                                                            />
                                                        </div></button>
                                                ) || (
                                                        <button
                                                            type="submit"
                                                            disabled={isLoading}
                                                            onClick={() => setIsRequestOtp(false)}
                                                            className={`${isLoading ? 'bg-primary bg-opacity-70' : 'bg-primary'
                                                                } flex-row flex items-center justify-center text-light rounded font-semibold text-xl p-4 w-full h-11`}
                                                        >
                                                            Login
                                                            <div className={`pl-2 ${isLoading ? 'visible' : 'invisible'}`}>
                                                                <RotatingLines
                                                                    visible={true}
                                                                    width={'20'}
                                                                    strokeColor="#fff"
                                                                    strokeWidth="6"
                                                                    animationDuration="0.75"
                                                                    ariaLabel="rotating-lines-loading"
                                                                />
                                                            </div>
                                                        </button>
                                                    )}

                                            </div>

                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div >
                </> :
                    <div className="flex h-screen bg-[#F8F8F8]">
                        <div className="container mx-auto px-4 ">
                            <div className="flex content-center items-center justify-start h-full">
                                <div className="w-1/2 h-max px-6">
                                    <div className="bg-white flex flex-col items-end justify-around h-full">
                                        <div className="flex flex-col justify-center w-full h-screen px-4 px-3">
                                            <div className="flex flex-col justify-center items-center w-full text-3xl font-bold my-3">

                                                Log In
                                                <svg width="172" height="29" viewBox="0 0 172 29" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 5.08742C17.6667 19.0972 30.5 31.1305 62.5 27.2693C110.617 21.4634 150 -10.09 171 5.08727" stroke="#FFBB38"></path></svg>
                                            </div>
                                            <div className="w-full my-5">
                                                <div>
                                                    <label className="block text-sm font-light mb-2">
                                                        Email/Phone Number*
                                                    </label>
                                                    <input

                                                        type="text"
                                                        {...register('Email', {
                                                            required: true,
                                                         
                                                        })}
                                                        className="border-0 px-3 py-3 text-black rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                                        placeholder="Username"
                                                        onChange={(e) => {
                                                            handleSteps(e, 'Email'),
                                                                setValue('Email', e.target.value || steps?.Email)
                                                        }}
                                                        value={steps?.Email}

                                                    />
                                                    {errors.Email?.type === 'required' && (
                                                        <span role="alert" className="w-full text-red-500 bg-white text-xs my-1">
                                                            This is required
                                                        </span>
                                                    )}
                                               
                                                </div>

                                            </div>
                                            <div className="w-full my-5">


                                            </div>


                                            {isLoginWithOTP && !isOtpChecked &&
                                                (<div>

                                                    <input
                                                        className="text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 d"
                                                        type="number"
                                                        placeholder="OTP"
                                                        {...register('otp', {
                                                            required: `OTP is required`,
                                                        })}
                                                        onChange={(event) => {
                                                            handleChange(
                                                                event.target.value,
                                                                'otp'
                                                            );
                                                        }}
                                                        value={loginValues?.otp}
                                                    />
                                                </div>)
                                            }




                                            <div className="text-center mt-6">

                                                {!isLoginWithOTP && (
                                                    <button type="submit" disabled={isLoading} onClick={() => setIsRequestOtp(true)} className={`${isLoading ? 'bg-primary bg-opacity-70' : 'bg-primary'
                                                        } flex-row flex items-center justify-center text-light rounded font-semibold text-xl p-4 w-full h-11`}
                                                    >Request OTP
                                                        <div className={`pl-2 ${isLoading ? 'visible' : 'invisible'}`}>
                                                            <RotatingLines
                                                                visible={true}
                                                                width={'20'}
                                                                strokeColor="#fff"
                                                                strokeWidth="6"
                                                                animationDuration="0.75"
                                                                ariaLabel="rotating-lines-loading"
                                                            />
                                                        </div></button>
                                                ) || (
                                                        <button
                                                            type="submit"
                                                            disabled={isLoading}
                                                            onClick={() => setIsRequestOtp(false)}
                                                            className={`${isLoading ? 'bg-primary bg-opacity-70' : 'bg-primary'
                                                                } flex-row flex items-center justify-center text-light rounded font-semibold text-xl p-4 w-full h-11`}
                                                        >
                                                            Login
                                                            <div className={`pl-2 ${isLoading ? 'visible' : 'invisible'}`}>
                                                                <RotatingLines
                                                                    visible={true}
                                                                    width={'20'}
                                                                    strokeColor="#fff"
                                                                    strokeWidth="6"
                                                                    animationDuration="0.75"
                                                                    ariaLabel="rotating-lines-loading"
                                                                />
                                                            </div>
                                                        </button>
                                                    )}

                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div className="w-1/2 h-screen  flex justify-center items-center px-20">
                                    <img src={require('../../assets/img/cart.png')} />
                                </div>
                            </div>
                        </div>
                    </div >}

            </form >
        </>
    );
}
